'use strict';
const angular = require('angular');

export class VoterLookupComponent {
  /*@ngInject*/
  constructor(User) {
    this.User = User;

    this.data = [];
    this.selectedUsers = [];

    this.User.query((data) => {
      this.data = data.map(user => {

        let contact = {
          _id: user._id,
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName
        };

        let property = {
          lotNo: "?",
          address: {
            street: "?"
          }
        };

        return {
          contact,
          property
        }

      });

      User.querySuite(data => {

        if (data && data[0]) {
          this.data = this.data.concat(data.filter(d => d.json).map(d => JSON.parse(d.json)));
        }

      }, err => {
        console.log("Could not retrieve properties.")
      });
    });
  }

  getRole(user) {
    let userId = user.contact._id;
    let oRole = user.property.contacts.find(c => c.contact == userId);

    return (oRole) ? oRole.type : "-";
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(user) {
    this.close({$value: this.selectedUsers});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getIndexUser(user) {
    return this.selectedUsers.map(function(x) {return x.contact._id; }).indexOf(user.contact._id);
  }

  addUser(user) {
    this.selectedUsers.push(user);
  }

  removeUser(user) {
    var idx = this.getIndexUser(user);
    this.selectedUsers.splice(idx,1);
  }

  isUserSelected(user) {
    return -1 !== this.getIndexUser(user);
  }
}

export default angular.module('conduu.voterLookup', [])
  .component('voterLookup', {
    template: require('./voter-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: VoterLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/voter-lookup/voter-lookup.component.js